import { Box, Rating, Checkbox, Button, makeStyles, Grid, Typography, Grid2 } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../screens/ProductList/ProductList";

const HEIGHT = window.innerHeight
const WIDTH = window.innerWidth
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

type Props = {
    product: any
};

export const ProductListView: React.FC<any> = ({ product }) => {
    const styles = useStyles();
    const history = useNavigate();
    const [saleLabel, setSaleLabel] = useState<string>("");

    useEffect(() => {
        if (product.productDiscount && product.productDiscount.discountType == 'PERCENTAGE') {
            setSaleLabel(product.productDiscount.discountValue + "% OFF")
        }
        if (product.productDiscount && product.productDiscount.discountType == 'FIXED_AMOUNT') {
            setSaleLabel("$" + product.productDiscount.discountValue + " OFF")
        }
    })
    const handleView = (e: any, item: any) => {
        history("/productdetail", { state: item.id });
    }

    return (
        <Box
            onClick={() =>
                history("/productdetail", { state: product.productId })
            }
            // onClick={nav}
            sx={{
                boxShadow: 2,
            }}
            className={styles.BestBoxs}>
            <Grid2 container spacing={4}>
                <Grid2 size={{ xs: 3.5 }}>
                    <Box
                        style={{ alignItems: "center", justifyContent: "center", marginTop: 2, marginBottom: 2, width: '100%' }}>
                        <Box style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                            <Box component="img" sx={{ width: "16%" }}
                                src={require('../../../assets/sale.png')} />
                        </Box>
                        <Box
                            component="img"
                            style={{ width: '100%', objectFit: 'contain' }}
                            src={product?.productImageUrl ? product.productImageUrl : require('../../../assets/Home/Cctv.png')} />
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 8.5 }}>
                    <Box style={{ display: 'flex', flexDirection: 'column' }}>
                        <Box>
                            <label className={styles.bestText}>{product.displayName ? product.displayName : ""}</label>
                        </Box>
                        <Box sx={{ flexDirection: 'row', display: 'flex', mb: 1 }}>
                            <Box sx={{ '& .MuiRating-icon': { fontSize: 18, mt: 3 } }}>
                                <Rating value={product.averageRating ? product.averageRating : 0} readOnly precision={0.5} size={'small'} sx={{ mr: 1 }} />
                            </Box>
                            <Box sx={{ mt: 2.6 }}>
                                <Typography sx={{ fontSize: 16, color: "#777777" }}>({product.totalRatings})</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ flexDirection: 'row', display: 'flex', mb: 1 }}>
                            <Box style={{ flexDirection: "row" }}>
                                {product.salePrice ? <label className={styles.orgText}>${product.salePrice}</label> : <label className={styles.orgText}>$0</label>}
                                {product.mrpPrice ? <label className={product.productDiscount ? styles.crsText : styles.crsTextNormal}>MRP ${product.mrpPrice}</label> : <label className={styles.crsText}>$0</label>}
                            </Box>
                        </Box>
                        <Typography sx={{
                            //fontSize: 12, color: "#777777", 
                            mb: 1, display: "-webkit-box",
                            overflow: "hidden",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                        }} variant="subtitle1">{product.longDesc ? product.longDesc : ""}</Typography>
                        <Box sx={{ flexDirection: "row", alignItems: "center", mt: 4, width: '100%', display: 'flex' }}>
                            <Box className={styles.buyBtn}>
                                <Button color="primary" sx={{ color: 'white', textAlign: 'center' }} onClick={(e) => {
                                    handleView(e, product);
                                }}>VIEW</Button>
                            </Box>
                            {/* <Box className={styles.buyBtn}>
                                <Box component="img"
                                    style={{ marginRight: WIDTH * 0.7 / 100 }}
                                    src={require('../../../assets/Home/buycart.png')} />
                                <label className={styles.buyText}>BUY NOW</label>
                            </Box>
                            <Box style={{ display: "flex", flexDirection: "row", width: WIDTH < 400 ? 200 : '' }}>
                                <Box component="img"
                                    style={{ height: HEIGHT * 2 / 100, marginLeft: WIDTH * 2 / 100 }}
                                    src={require('../../../assets/Home/addcart.png')} />
                                <label style={{ color: "#898989", fontSize: 12, marginLeft: WIDTH * 0.5 / 100, fontWeight: "600" }}>ADD TO CART</label>
                            </Box>
                            <Box style={{ display: "flex", flexDirection: "row" }}>
                                <Box component="img"
                                    style={{ height: HEIGHT * 2 / 100, marginLeft: WIDTH * 2 / 100 }}
                                    src={require('../../../assets/Home/Like.png')} />
                                <label style={{ color: "#898989", fontSize: 12, marginLeft: WIDTH * 0.5 / 100, fontWeight: "600" }}>ADD TO FAVORITE</label>
                            </Box> */}
                        </Box>
                        {/* <Box sx={{ flexDirection: "row", alignItems: "center", mb: 1, width: '100%', display: 'flex' }}>
                            <Box style={{ flexDirection: "row", display: 'flex', alignItems: "center", width: WIDTH < 400 ? '100%' : '25%' }}>
                                <Checkbox name="antoine" {...label} sx={{ p: 0, mr: 0.5 }} size="small" />
                                <Typography style={{ fontSize: 11 }}>Compare</Typography>
                            </Box>
                            <Box sx={{ '& .MuiRating-icon': { fontSize: 12, mt: 3 } }}>
                                <Rating value={averageRating ? averageRating : 0} readOnly precision={0.5} size={'small'} />
                            </Box>
                            <Box style={{ flexDirection: "row", alignItems: "center", marginLeft: '2px', marginBottom: '5px' }} sx={{ mt: 3 }}>
                                <label className={styles.starCount}>({totalRating})</label>
                            </Box>
                        </Box> */}

                    </Box>
                </Grid2>
            </Grid2>
        </Box >
    );
};